export function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return function (val) { return fns.reduce(function (arg, fn) { return fn(arg); }, val); };
}
//# sourceMappingURL=pipe.js.map